export interface ProjectInfrastructureInfoResult {
  code: string;
  message: string;
  success: string;
}
